// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-select-dropdown{max-width:40%}.el-select-dropdown__item{overflow:visible}", ""]);
// Exports
module.exports = exports;
